import wx from 'weixin-js-sdk'

export default {
  install (Vue, options) {
    Vue.prototype.$wx = wx
  }
}
